import axios from 'axios'
import { constants } from '../../App.constants'

/**
 * The member's own autopay (dashboards-api GET/PUT /organization/:orgId/autopay).
 * Callbacks get (err, data); err is { status, code, message }.
 */

const url = () => constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/autopay'

const config = (loginToken) => ({
    headers: { 'Content-Type': 'application/json', 'login-token': loginToken }
})

const settle = async (request, cb) => {
    try {
        const payload = await request()
        const body = (payload && payload.data) || {}
        if (body.error) {
            return cb({ status: payload.status || 0, code: body.code || null, message: body.message || 'error' })
        }
        cb(null, body.data)
    } catch (error) {
        const res = error && error.response
        const body = (res && res.data) || {}
        cb({ status: res ? res.status : 0, code: body.code || null, message: body.message || (error && error.message) || 'error' })
    }
}

export const getAutopay = (loginToken, cb) => settle(() => axios.get(url(), config(loginToken)), cb)

export const setAutopay = (loginToken, enabled, cb) => settle(() => axios.put(url(), { enabled }, config(loginToken)), cb)
